import SHARED_META from './shared'
import { SHARED_META_ZAVA } from './zava.shared'

export default {
  de_DE: {
    title: 'ZAVA Online-Arzt: Ihre Diagnose online &ndash; ohne Wartezeit | ZAVA - DrEd',
    meta: [
      ...SHARED_META,
      ...SHARED_META_ZAVA,
      {
        property: 'og:title',
        content: 'ZAVA Online-Arzt: Ihre Diagnose online &ndash; ohne Wartezeit'
      },
      {
        property: 'og:description',
        content: 'Die Online-Arztpraxis ZAVA bietet schnelle &amp; kompetente Diagnose &amp; Behandlung aus der Ferne. Ob Tag oder Nacht: Rezept &amp; Medikament online &ndash; ohne Wartezeit.'
      },
      {
        property: 'og:url',
        content: 'https://www.zavamed.com/de/'
      },
      {
        property: 'og:image',
        content: 'https://www.zavamed.com/de/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'twitter:title',
        content: 'ZAVA Online-Arzt: Ihre Diagnose online &ndash; ohne Wartezeit'
      },
      {
        name: 'twitter:description',
        content: 'Die Online-Arztpraxis ZAVA bietet schnelle &amp; kompetente Diagnose &amp; Behandlung aus der Ferne. Ob Tag oder Nacht: Rezept &amp; Medikament online &ndash; ohne Wartezeit.'
      },
      {
        name: 'twitter:site',
        content: '@zavamed_de'
      },
      {
        name: 'twitter:image',
        content: 'https://www.zavamed.com/de/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'msapplication-TileImage',
        content: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/ms-icon-144x144.png'
      }
    ],
    link: [
      {
        rel: 'apple-touch-icon',
        sizes: '57x57',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-57x57.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '60x60',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-60x60.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '72x72',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-72x72.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '76x76',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-76x76.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '114x114',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-114x114.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '120x120',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-120x120.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '144x144',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-144x144.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-152x152.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/apple-icon-180x180.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/android-icon-192x192.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/favicon-32x32.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/favicon-96x96.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: 'https://www.zavamed.com/de/assets/dist/images/favicons/zava/favicon-16x16.png'
      }
    ]
  }
}
